import React from 'react';
import { Modal } from '../modal/Modal';
import { Container, Stack, Text, Grid, Button } from 'basis';

interface Props {
  showWarning: boolean;
  secondsRemaining: number;
  handleContinueSession: () => void;
  handleExitSession: () => void;
}

export const InactivityTimeoutModal: React.FC<Props> = ({
  showWarning,
  secondsRemaining,
  handleContinueSession,
  handleExitSession,
}) => {
  if (showWarning) {
    return (
      <Modal isOpen={true} onClose={() => { }} disableClose={true} testId="inactivity-timeout-modal">
        <Container padding="3" padding-md="6" testId="SessionTimeout">
          <Stack gap="6" gap-md="10">
            <Text textStyle="heading5">Your session is about to expire</Text>
            <Text>
              Your session will expire in <b data-testid="CountDown">{secondsRemaining} seconds</b> due to inactivity. Do
              you want to continue your session?
            </Text>
            <Container padding-md="0 14">
              <Grid>
                <Grid.Item colSpan="all" colSpan-md="0-1">
                  <Container padding="2 0" padding-md="2">
                    <Button type="button" width="100%" variant="secondary" testId="EndButton" onClick={handleExitSession}>
                      Exit
                    </Button>
                  </Container>
                </Grid.Item>
                <Grid.Item colSpan="all" colSpan-md="2-3">
                  <Container padding="2 0" padding-md="2">
                    <Button type="button" width="100%" testId="ExtendButton" onClick={handleContinueSession}>
                      Continue
                    </Button>
                  </Container>
                </Grid.Item>
              </Grid>
            </Container>
          </Stack>
        </Container>
      </Modal>
    );
  }

  return null;
};
